import { reactive } from 'vue'

export const appUpdateState = reactive({ available: false, deferred: false, applying: false, blockedElsewhere: false })

export function createAppUpdates({ hasChanges, isBusy, serviceWorker, reload, onDeferred,
  state = appUpdateState }) {
  let registration = null
  let worker = null
  let activated = false
  let hadController = !!serviceWorker?.controller
  let disposed = false
  let reloading = false
  const blocked = () => hasChanges() || isBusy()
  const defer = reason => {
    state.deferred = true; state.applying = false
    state.blockedElsewhere = reason === 'other-tabs'
    onDeferred?.(reason)
  }
  const message = event => {
    if (event.data?.type === 'RC_UPDATE_SAFETY_CHECK') event.ports[0]?.postMessage({ safe: !blocked() })
    if (event.data?.type === 'RC_UPDATE_BLOCKED') defer('other-tabs')
  }
  serviceWorker?.addEventListener('message', message)
  const finish = () => {
    if (disposed || reloading) return
    activated = true
    state.available = true
    if (!state.applying) return
    if (blocked()) { defer(); return }
    state.available = false
    reloading = true
    reload()
  }
  const changed = () => {
    if (worker?.state === 'activated') finish()
    if (worker?.state === 'redundant') { state.applying = false; state.deferred = true }
  }
  const controllerChanged = () => {
    if (!hadController && !state.applying) { hadController = true; return }
    hadController = true
    finish()
  }
  serviceWorker?.addEventListener('controllerchange', controllerChanged)
  return {
    offer(value) {
      registration = value
      state.available = true
      if (blocked()) { defer(); return false }
      return true
    },
    apply() {
      if (disposed || state.applying) return false
      // Also check after the confirmation dialog: the user may have edited another field.
      if (blocked()) { defer(); return false }
      state.deferred = false
      state.blockedElsewhere = false
      state.applying = true
      if (activated) { state.available = false; reloading = true; reload(); return true }
      const waiting = registration?.waiting
      if (!waiting) { state.applying = false; return false }
      worker?.removeEventListener('statechange', changed)
      worker = waiting
      worker.addEventListener('statechange', changed)
      worker.postMessage({ type: 'SKIP_WAITING' })
      return true
    },
    canApply() { return !blocked() },
    defer,
    dispose() {
      disposed = true
      worker?.removeEventListener('statechange', changed)
      serviceWorker?.removeEventListener('controllerchange', controllerChanged)
      serviceWorker?.removeEventListener('message', message)
    },
  }
}
